export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAEklEQVQIHWNgIBn8BwKSNTEAANGXA/220LalAAAAAElFTkSuQmCC"